// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3525":"de8bccb2","4232":"decd1a2f","5546":"567675ed","7173":"dc69002f"}[chunkId] + ".chunk.css";
};